// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function decodeErrorMessage(param) {
  return /* DefaultError */{
          _0: {
            title: /* Unauthorized */1,
            message: "Authentication Error"
          }
        };
}

function execute(data) {
  if (typeof data === "number" || data.TAG !== /* Unauthorized */4) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(data);
  } else {
    return /* DefaultError */{
            _0: {
              title: /* Unauthorized */1,
              message: "Authentication Error"
            }
          };
  }
}

export {
  decodeErrorMessage ,
  execute ,
  
}
/* ResponseHandler-Catalyst Not a pure module */
